import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import RecallDetailsView from "../../Models/Recall/RecallDetailsView";

export default (id: string | number) =>
  axiosApi.get<RecallDetailsView>(
    `${BackendServices.RECALL_SERVICE.RECALL}/${id}`
  );
